import type { AgentUiResponse } from "@contractor-quoting/shared-types";
import type { ChatDraftMessage } from "./chat-draft.js";

export interface ContractorPublic {
  contractor: { name: string; serviceArea: string | null };
  jobOfferings: Array<{
    code: string;
    name: string;
    requestedTrades: string[];
    coveredTrades: string[];
    uncoveredTrades: string[];
  }>;
}

export type ChatMessage = ChatDraftMessage;

export interface InitialChatState {
  contractor: ContractorPublic["contractor"];
  projectId: string;
  projectStatus: string;
  messages: ChatMessage[];
  input: string;
  warning?: string;
}

export type ViewerMode = "checking" | "anonymous" | "customer" | "contractor";

export const chatSteps = [
  "Project details",
  "Room measurements",
  "Material selection",
  "Additional details",
  "Review & confirm",
  "Get estimate",
];

export const chatSuggestions = [
  "I’m replacing flooring in my kitchen",
  "Help me understand what to measure",
  "I’m not sure which material I want",
];

export function toChatMessage(response: AgentUiResponse): ChatMessage {
  if (response.type === "message") return { id: response.id, role: "agent", text: response.text };
  if (response.type === "requirement") {
    return {
      id: response.id,
      role: "status",
      text: `Still needed: ${response.requirement.replaceAll("_", " ")}`,
    };
  }
  return {
    id: response.id,
    role: "status",
    text: `${response.completed} of ${response.total} project details complete`,
    completed: response.completed,
    total: response.total,
  };
}
